"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            totalProducts: 0,
            totalCustomers: 0,
            newProducts: 0,
            newCustomers: 0,
            salesHistory: null,
            generalReports: null
        };
    },
    onMount: function () {
        const $chartBoard = $('#chart-board'), dataset = {};
        ResalersIncome($chartBoard, dataset);
        CustomerIncome($chartBoard, dataset);
        OrderSummary($chartBoard, dataset);
        YealyTraffic($chartBoard, dataset);
        ProfitReport($chartBoard, dataset);
        Referrals($chartBoard, dataset);
        WeeklySales($chartBoard, dataset);
        Subscription($chartBoard, dataset);
        RevenueGrowth($chartBoard, dataset);
        BusinessGrowth($chartBoard, dataset);
        ImpressionReport($chartBoard, dataset);
    },
    getSalesHistory: async function () {
        const {error, message, results} = await Request('/sale/list');
        console.log('Sales:', results);
        this.state.salesHistory = results.slice(0, 3);
    },
    getGeneralReport: async function () {
        const {error, message, analytics} = await Request('/analytics?&site=online&format=true');
        this.state.totalProducts = analytics.dataset.totals.products.total;
        this.state.totalCustomers = analytics.dataset.totals.customers;
        this.state.generalReports = analytics;
    },
    getNewReport: async function () {
        const month = new Date().toLocaleString('default', { month: 'long' });
        const {error, message, analytics} = await Request('/analytics?month=' + month + '&site=online&format=true');
        this.state.newProducts = analytics.dataset.totals.products.total;
        this.state.newCustomers = analytics.dataset.totals.customers;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Analytics/Admin/Dashboard.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_reportChart_module = require("./reportChart"),
    reportChart_module = module_reportChart_module.default || module_reportChart_module,
    ResalersIncome = module_reportChart_module.ResalersIncome,
    CustomerIncome = module_reportChart_module.CustomerIncome,
    OrderSummary = module_reportChart_module.OrderSummary,
    YealyTraffic = module_reportChart_module.YealyTraffic,
    ProfitReport = module_reportChart_module.ProfitReport,
    Referrals = module_reportChart_module.Referrals,
    WeeklySales = module_reportChart_module.WeeklySales,
    Subscription = module_reportChart_module.Subscription,
    RevenueGrowth = module_reportChart_module.RevenueGrowth,
    BusinessGrowth = module_reportChart_module.BusinessGrowth,
    ImpressionReport = module_reportChart_module.ImpressionReport,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_template = require("../../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("fceedc"),
    marko_node0 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "col-xl-8 col-lg-7 col-12"
      },
    marko_attrs1 = {
        "class": "row"
      },
    marko_attrs2 = {
        "class": "col-xl-4 col-lg-12 col-md-6 col-12"
      },
    marko_attrs3 = {
        "class": "card theme-bg border rounded fixed-height"
      },
    marko_attrs4 = {
        "class": "card-header d-flex justify-content-between align-items-center pb-50"
      },
    marko_attrs5 = {
        "class": "card-title"
      },
    marko_node1 = marko_createElement("div", {
        "class": "dropdown"
      }, "12", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          "class": "btn btn-sm btn-outline-secondary dropdown-toggle",
          type: "button",
          id: "dropdownMenuButtonSec",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, null, null, 1)
        .t("2020")
      .e("div", {
          "class": "dropdown-menu",
          "aria-labelledby": "dropdownMenuButtonSec"
        }, null, null, 2)
        .e("a", {
            "class": "dropdown-item",
            href: "#"
          }, null, null, 1)
          .t("2020")
        .e("a", {
            "class": "dropdown-item",
            href: "#"
          }, null, null, 1)
          .t("2019"),
    marko_attrs6 = {
        "class": "card-content"
      },
    marko_attrs7 = {
        "class": "card-body p-0 pb-1"
      },
    marko_attrs8 = {
        "class": "list-group list-group-flush"
      },
    marko_attrs9 = {
        "class": "list-group-item theme-bg nav-item list-group-item-action border-0 d-flex align-items-center justify-content-between"
      },
    marko_attrs10 = {
        "class": "list-left d-flex"
      },
    marko_node2 = marko_createElement("div", {
        "class": "list-icon mr-1"
      }, "22", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "avatar bg-rgba-primary"
        }, null, null, 1)
        .e("div", {
            "class": "avatar-content"
          }, null, null, 1)
          .e("i", {
              "class": "bx bx-briefcase-alt text-primary font-size-base"
            }, null, null, 0),
    marko_attrs11 = {
        "class": "list-content"
      },
    marko_attrs12 = {
        "class": "list-title"
      },
    marko_attrs13 = {
        "class": "text-muted d-block"
      },
    marko_attrs14 = {
        "class": "list-group-item theme-bg nav-item list-group-item-action border-0 d-flex align-items-center justify-content-between"
      },
    marko_attrs15 = {
        "class": "list-left d-flex"
      },
    marko_node3 = marko_createElement("div", {
        "class": "list-icon mr-1"
      }, "33", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "avatar bg-rgba-success"
        }, null, null, 1)
        .e("div", {
            "class": "avatar-content"
          }, null, null, 1)
          .e("i", {
              "class": "bx bx-group text-success font-size-base"
            }, null, null, 0),
    marko_attrs16 = {
        "class": "list-content"
      },
    marko_attrs17 = {
        "class": "list-title"
      },
    marko_attrs18 = {
        "class": "text-muted d-block"
      },
    marko_attrs19 = {
        "class": "list-group-item theme-bg nav-item list-group-item-action border-0 d-flex align-items-center justify-content-between"
      },
    marko_attrs20 = {
        "class": "list-left d-flex w-100 align-items-center"
      },
    marko_node4 = marko_createElement("div", {
        "class": "list-icon mr-1"
      }, "44", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "avatar bg-rgba-danger"
        }, null, null, 1)
        .e("div", {
            "class": "avatar-content"
          }, null, null, 1)
          .e("i", {
              "class": "bx bx-walk text-danger p-50 font-size-base"
            }, null, null, 0),
    marko_attrs21 = {
        "class": "list-content"
      },
    marko_attrs22 = {
        "class": "list-title"
      },
    marko_node5 = marko_createElement("small", {
        "class": "text-muted d-block"
      }, "51", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("55 New"),
    marko_node6 = marko_createElement("span", null, "52", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("4.6k"),
    marko_attrs23 = {
        "class": "col-xl-4 col-lg-12 col-md-6 col-12"
      },
    marko_attrs24 = {
        "class": "card theme-bg border rounded fixed-height"
      },
    marko_attrs25 = {
        "class": "card-header d-flex justify-content-between align-items-center"
      },
    marko_attrs26 = {
        "class": "card-title-content"
      },
    marko_attrs27 = {
        "class": "card-title"
      },
    marko_attrs28 = {
        "class": "text-muted"
      },
    marko_node7 = marko_createElement("i", {
        "class": "bx bx-dots-vertical-rounded font-medium-5 cursor-pointer"
      }, "61", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs29 = {
        "class": "card-content"
      },
    marko_attrs30 = {
        "class": "card-body"
      },
    marko_node8 = marko_createElement("div", {
        id: "weekly-sales-chart",
        "class": "mb-2"
      }, "64", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs31 = {
        "class": "d-flex justify-content-between my-1"
      },
    marko_attrs32 = {
        "class": "sales-info d-flex align-items-center"
      },
    marko_node9 = marko_createElement("i", {
        "class": "bx bx-up-arrow-circle text-primary font-medium-5 mr-50"
      }, "67", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs33 = {
        "class": "sales-info-content"
      },
    marko_attrs34 = {
        "class": "mb-0"
      },
    marko_node10 = marko_createElement("small", {
        "class": "text-muted"
      }, "71", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Sunday"),
    marko_attrs35 = {
        "class": "d-flex justify-content-between mt-2"
      },
    marko_attrs36 = {
        "class": "sales-info d-flex align-items-center"
      },
    marko_node11 = marko_createElement("i", {
        "class": "bx bx-down-arrow-circle icon-light font-medium-5 mr-50"
      }, "75", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs37 = {
        "class": "sales-info-content"
      },
    marko_attrs38 = {
        "class": "mb-0"
      },
    marko_node12 = marko_createElement("small", {
        "class": "text-muted"
      }, "79", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Thursday"),
    marko_node13 = marko_createElement("div", {
        "class": "col-xl-4 col-lg-12 col-md-6 col-12"
      }, "81", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card theme-bg border rounded fixed-height"
        }, null, null, 1)
        .e("div", {
            "class": "card-body text-center"
          }, null, null, 3)
          .e("div", {
              "class": "dropdown"
            }, null, null, 2)
            .e("button", {
                "class": "btn btn-sm btn-outline-secondary dropdown-toggle",
                type: "button",
                id: "dropdownMenuButtonSec",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, null, null, 1)
              .t("2020")
            .e("div", {
                "class": "dropdown-menu",
                "aria-labelledby": "dropdownMenuButtonSec"
              }, null, null, 2)
              .e("a", {
                  "class": "dropdown-item",
                  href: "#"
                }, null, null, 1)
                .t("2020")
              .e("a", {
                  "class": "dropdown-item",
                  href: "#"
                }, null, null, 1)
                .t("2019")
          .e("div", {
              id: "business-growth-chart"
            }, null, null, 0)
          .e("h6", {
              "class": "mb-0"
            }, null, null, 1)
            .t(" 78% Business Growth in 2020"),
    marko_attrs39 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs40 = {
        "class": "row"
      },
    marko_attrs41 = {
        "class": "col-md-8 col-12 order-summary border-right pr-md-0"
      },
    marko_attrs42 = {
        "class": "card theme-bg mb-0"
      },
    marko_attrs43 = {
        "class": "card-header d-flex justify-content-between align-items-center"
      },
    marko_attrs44 = {
        "class": "card-title"
      },
    marko_node14 = marko_createElement("div", {
        "class": "d-flex"
      }, "99", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          type: "button",
          "class": "btn btn-sm btn-light-primary mr-1"
        }, null, null, 1)
        .t("Month")
      .e("button", {
          type: "button",
          "class": "btn btn-sm btn-primary glow"
        }, null, null, 1)
        .t("Week"),
    marko_node15 = marko_createElement("div", {
        "class": "card-content"
      }, "102", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card-body p-0"
        }, null, null, 1)
        .e("div", {
            id: "order-summary-chart"
          }, null, null, 0),
    marko_attrs45 = {
        "class": "col-md-4 col-12 pl-md-0"
      },
    marko_attrs46 = {
        "class": "card theme-bg mb-0"
      },
    marko_attrs47 = {
        "class": "card-header pb-50"
      },
    marko_attrs48 = {
        "class": "card-title"
      },
    marko_attrs49 = {
        "class": "card-content"
      },
    marko_attrs50 = {
        "class": "card-body py-1"
      },
    marko_attrs51 = {
        "class": "card-footer border-top pb-0"
      },
    marko_node16 = marko_createElement("h5", null, "117", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Total Sales"),
    marko_node17 = marko_createElement("div", {
        "class": "progress progress-bar-primary progress-sm my-50"
      }, "119", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "progress-bar",
          role: "progressbar",
          "aria-valuenow": "78",
          style: "width:78%"
        }, null, null, 0),
    marko_attrs52 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs53 = {
        "class": "card-header d-flex justify-content-between align-items-center"
      },
    marko_attrs54 = {
        "class": "card-title"
      },
    marko_node18 = marko_createElement("i", {
        "class": "bx bx-dots-vertical-rounded font-medium-5 cursor-pointer"
      }, "126", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs55 = {
        "class": "card-content"
      },
    marko_attrs56 = {
        "class": "card-body pb-1"
      },
    marko_attrs57 = {
        "class": "d-flex justify-content-around align-items-center flex-wrap"
      },
    marko_attrs58 = {
        "class": "user-analytics"
      },
    marko_node19 = marko_createElement("i", {
        "class": "bx bx-user mr-25 align-middle"
      }, "131", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs59 = {
        "class": "align-middle text-muted"
      },
    marko_node20 = marko_createElement("div", {
        "class": "d-flex"
      }, "134", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          id: "trafic-customers-chart"
        }, null, null, 0)
      .e("h3", {
          "class": "mt-1 ml-50"
        }, null, null, 1)
        .t("61K"),
    marko_node21 = marko_createElement("div", {
        "class": "sessions-analytics"
      }, "137", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-trending-up align-middle mr-25"
        }, null, null, 0)
      .e("span", {
          "class": "align-middle text-muted"
        }, null, null, 1)
        .t("Sessions")
      .e("div", {
          "class": "d-flex"
        }, null, null, 2)
        .e("div", {
            id: "trafic-sessions-chart"
          }, null, null, 0)
        .e("h3", {
            "class": "mt-1 ml-50"
          }, null, null, 1)
          .t("92K"),
    marko_node22 = marko_createElement("div", {
        "class": "bounce-rate-analytics"
      }, "143", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-pie-chart-alt align-middle mr-25"
        }, null, null, 0)
      .e("span", {
          "class": "align-middle text-muted"
        }, null, null, 1)
        .t("Bounce Rate")
      .e("div", {
          "class": "d-flex"
        }, null, null, 2)
        .e("div", {
            id: "trafic-bounce-rate-chart"
          }, null, null, 0)
        .e("h3", {
            "class": "mt-1 ml-50"
          }, null, null, 1)
          .t("72.6%"),
    marko_node23 = marko_createElement("div", {
        id: "yearly-trafic-analytics-chart"
      }, "149", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs60 = {
        "class": "row"
      },
    marko_attrs61 = {
        "class": "col-xl-6 col-lg-12 col-md-6 col-12"
      },
    marko_attrs62 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs63 = {
        "class": "card-header d-flex justify-content-between align-items-center"
      },
    marko_attrs64 = {
        "class": "card-title"
      },
    marko_node24 = marko_createElement("i", {
        "class": "bx bx-dots-vertical-rounded font-medium-5 cursor-pointer"
      }, "156", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs65 = {
        "class": "card-content"
      },
    marko_attrs66 = {
        "class": "card-body"
      },
    marko_node25 = marko_createElement("div", {
        id: "impression-report-chart",
        "class": "d-flex justify-content-center m-2"
      }, "159", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs67 = {
        "class": "list-inline d-flex justify-content-around mb-0"
      },
    marko_node26 = marko_createElement("span", {
        "class": "bullet bullet-sm bullet-success mr-50"
      }, "162", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node27 = marko_createElement("span", {
        "class": "bullet bullet-sm bullet-warning mr-50"
      }, "165", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node28 = marko_createElement("span", {
        "class": "bullet bullet-sm bullet-primary mr-50"
      }, "168", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node29 = marko_createElement("span", {
        "class": "bullet bullet-sm bullet-danger mr-50"
      }, "171", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node30 = marko_createElement("div", {
        "class": "col-xl-6 col-lg-12 col-md-6 col-12"
      }, "173", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs68 = {
        "class": "col-xl-4 col-lg-5 col-12 pl-4"
      },
    marko_attrs69 = {
        "class": "row"
      },
    marko_attrs70 = {
        "class": "col-sm-6 col-12"
      },
    marko_attrs71 = {
        "class": "card theme-bg border rounded text-center"
      },
    marko_attrs72 = {
        "class": "card-content"
      },
    marko_attrs73 = {
        "class": "card-body py-1"
      },
    marko_node31 = marko_createElement("div", {
        "class": "badge-circle badge-circle-lg theme-bg-lighten mx-auto mb-50"
      }, "180", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-briefcase-alt font-medium-5"
        }, null, null, 0),
    marko_attrs74 = {
        "class": "text-muted line-ellipsis"
      },
    marko_attrs75 = {
        "class": "mb-0"
      },
    marko_attrs76 = {
        "class": "col-sm-6 col-12"
      },
    marko_attrs77 = {
        "class": "card theme-bg border rounded text-center"
      },
    marko_attrs78 = {
        "class": "card-content"
      },
    marko_attrs79 = {
        "class": "card-body py-1"
      },
    marko_node32 = marko_createElement("div", {
        "class": "badge-circle badge-circle-lg  theme-bg-lighten mx-auto mb-50"
      }, "189", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-user font-medium-5"
        }, null, null, 0),
    marko_attrs80 = {
        "class": "text-muted line-ellipsis"
      },
    marko_attrs81 = {
        "class": "mb-0"
      },
    marko_attrs82 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs83 = {
        "class": "card-body d-flex align-items-center justify-content-between"
      },
    marko_attrs84 = {
        "class": "d-flex align-items-center"
      },
    marko_node33 = marko_createElement("div", {
        "class": "avatar bg-rgba-success p-50 mr-75"
      }, "197", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "avatar-content"
        }, null, null, 1)
        .e("i", {
            "class": "bx bx-group text-success font-medium-5"
          }, null, null, 0),
    marko_attrs85 = {
        "class": "total-amount"
      },
    marko_attrs86 = {
        "class": "text-muted"
      },
    marko_node34 = marko_createElement("div", {
        id: "customers-income-chart"
      }, "203", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs87 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs88 = {
        "class": "card-body d-flex align-items-center justify-content-between"
      },
    marko_attrs89 = {
        "class": "d-flex align-items-center"
      },
    marko_node35 = marko_createElement("div", {
        "class": "avatar bg-rgba-primary p-50 mr-75"
      }, "207", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "avatar-content"
        }, null, null, 1)
        .e("i", {
            "class": "bx bx-store text-primary font-medium-5"
          }, null, null, 0),
    marko_attrs90 = {
        "class": "total-amount"
      },
    marko_attrs91 = {
        "class": "text-muted"
      },
    marko_node36 = marko_createElement("div", {
        id: "resellers-income-chart"
      }, "213", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs92 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs93 = {
        "class": "card-header d-flex justify-content-between align-items-center pb-0"
      },
    marko_attrs94 = {
        "class": "card-title"
      },
    marko_attrs95 = {
        "class": "d-flex align-items-end justify-content-end"
      },
    marko_node37 = marko_createElement("i", {
        "class": "bx bx-dots-vertical-rounded font-medium-5 cursor-pointer"
      }, "219", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node38 = marko_createElement("div", {
        "class": "card-content"
      }, "220", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card-body pb-0"
        }, null, null, 1)
        .e("div", {
            id: "revenue-growth-chart"
          }, null, null, 0),
    marko_attrs96 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs97 = {
        "class": "card-header d-flex justify-content-between align-items-center"
      },
    marko_attrs98 = {
        "class": "card-title"
      },
    marko_node39 = marko_createElement("i", {
        "class": "bx bx-dots-vertical-rounded font-medium-5 cursor-pointer"
      }, "227", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs99 = {
        "class": "card-content"
      },
    marko_attrs100 = {
        "class": "card-body pb-0 d-flex justify-content-around"
      },
    marko_attrs101 = {
        "class": "d-inline-flex mr-xl-2"
      },
    marko_node40 = marko_createElement("div", {
        id: "profile-last-report-chart"
      }, "231", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs102 = {
        "class": "profit-content ml-50 mt-50"
      },
    marko_node41 = marko_createElement("small", {
        "class": "text-muted"
      }, "233", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Year 2019"),
    marko_attrs103 = {
        "class": "d-inline-flex"
      },
    marko_node42 = marko_createElement("div", {
        id: "profile-current-report-chart"
      }, "235", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs104 = {
        "class": "profit-content ml-50 mt-50"
      },
    marko_node43 = marko_createElement("small", {
        "class": "text-muted"
      }, "237", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Year 2020"),
    marko_attrs105 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs106 = {
        "class": "card-header"
      },
    marko_attrs107 = {
        "class": "card-title"
      },
    marko_node44 = marko_createElement("div", {
        "class": "card-content"
      }, "242", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card-body"
        }, null, null, 1)
        .e("div", {
            "class": "d-flex align-items-end justify-content-around"
          }, null, null, 2)
          .e("div", {
              "class": "registration-content mr-xl-2"
            }, null, null, 3)
            .e("h4", {
                "class": "mb-0"
              }, null, null, 1)
              .t("$32,690")
            .e("i", {
                "class": "bx bx-trending-up primary align-middle"
              }, null, null, 0)
            .e("span", {
                "class": "text-primary"
              }, null, null, 1)
              .t("44.6%")
          .e("div", {
              id: "referrals-chart"
            }, null, null, 0),
    marko_attrs108 = {
        "class": "card theme-bg border rounded"
      },
    marko_attrs109 = {
        "class": "card-header d-flex justify-content-between align-items-center"
      },
    marko_attrs110 = {
        "class": "card-title"
      },
    marko_node45 = marko_createElement("i", {
        "class": "bx bx-dots-vertical-rounded font-medium-5 cursor-pointer"
      }, "254", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node46 = marko_createElement("div", {
        "class": "card-content"
      }, "255", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card-body"
        }, null, null, 2)
        .e("div", {
            id: "user-subscriptions-chart"
          }, null, null, 0)
        .e("ul", {
            "class": "list-inline d-flex justify-content-around mb-0"
          }, null, null, 3)
          .e("li", null, null, null, 3)
            .t(" ")
            .e("span", {
                "class": "bullet bullet-sm bullet-primary mr-50"
              }, null, null, 0)
            .t("VendOne")
          .e("li", null, null, null, 3)
            .t(" ")
            .e("span", {
                "class": "bullet bullet-sm bullet-danger mr-50"
              }, null, null, 0)
            .t("Marketing")
          .e("li", null, null, null, 3)
            .t(" ")
            .e("span", {
                "class": "bullet bullet-sm bullet-info mr-50"
              }, null, null, 0)
            .t("Warehouse"),
    marko_node47 = marko_createElement("span", null, "72", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node48 = marko_createElement("span", null, "80", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs111 = {
        "class": "d-flex justify-content-between align-items-center mb-2"
      },
    marko_attrs112 = {
        "class": "sales-item-name"
      },
    marko_attrs113 = {
        "class": "sales-item-amount"
      },
    marko_attrs114 = {
        "class": "mb-0"
      },
    marko_attrs115 = {
        "class": "text-muted"
      },
    marko_node49 = marko_createElement("span", {
        "class": "text-primary text-bold-500"
      }, "118", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "pl-6 pr-6 py-md-4 py-2",
      scroll: true,
      renderBody: function(out) {
        out.be("h4", null, "1", component);

        Locale_tag({
            text: "Reports & Analytics"
          }, out, __component, "2");

        out.ee();

        out.n(marko_node0, component);

        Row_tag({
            id: "chart-board",
            renderBody: function(out) {
              out.be("div", marko_attrs0, "5", component);

              out.be("section", marko_attrs1, "6", component);

              out.be("div", marko_attrs2, "7", component);

              out.be("div", marko_attrs3, "8", component);

              out.be("div", marko_attrs4, "9", component);

              out.be("h4", marko_attrs5, "10", component);

              Locale_tag({
                  text: "Latest Update"
                }, out, __component, "11");

              out.ee();

              out.n(marko_node1, component);

              out.ee();

              out.be("div", marko_attrs6, "17", component);

              out.be("div", marko_attrs7, "18", component);

              out.be("ul", marko_attrs8, "19", component);

              out.be("li", marko_attrs9, "20", component);

              out.be("div", marko_attrs10, "21", component);

              out.n(marko_node2, component);

              out.be("div", marko_attrs11, "26", component);

              out.be("span", marko_attrs12, "27", component);

              Locale_tag({
                  text: "Total Products"
                }, out, __component, "28");

              out.ee();

              out.e("small", marko_attrs13, "29", component, 2)
                .t(state.newProducts, component)
                .t(" New");

              out.ee();

              out.ee();

              out.e("span", null, "30", component, 1)
                .t(state.totalProducts, component);

              out.ee();

              out.be("li", marko_attrs14, "31", component);

              out.be("div", marko_attrs15, "32", component);

              out.n(marko_node3, component);

              out.be("div", marko_attrs16, "37", component);

              out.be("span", marko_attrs17, "38", component);

              Locale_tag({
                  text: " Total Customers"
                }, out, __component, "39");

              out.ee();

              out.e("small", marko_attrs18, "40", component, 2)
                .t(state.newCustomers, component)
                .t(" New");

              out.ee();

              out.ee();

              out.e("span", null, "41", component, 1)
                .t(state.totalCustomers, component);

              out.ee();

              out.be("li", marko_attrs19, "42", component);

              out.be("div", marko_attrs20, "43", component);

              out.n(marko_node4, component);

              out.be("div", marko_attrs21, "48", component);

              out.be("span", marko_attrs22, "49", component);

              Locale_tag({
                  text: "Total Followers"
                }, out, __component, "50");

              out.ee();

              out.n(marko_node5, component);

              out.ee();

              out.ee();

              out.n(marko_node6, component);

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.be("div", marko_attrs23, "53", component);

              out.be("div", marko_attrs24, "54", component);

              out.be("div", marko_attrs25, "55", component);

              out.be("div", marko_attrs26, "56", component);

              out.be("h4", marko_attrs27, "57", component);

              Locale_tag({
                  text: "Sales"
                }, out, __component, "58");

              out.t(" ");

              out.ee();

              out.be("small", marko_attrs28, "59", component);

              Locale_tag({
                  text: "Calculated in last 7 days"
                }, out, __component, "60");

              out.ee();

              out.ee();

              out.n(marko_node7, component);

              out.ee();

              out.be("div", marko_attrs29, "62", component);

              out.be("div", marko_attrs30, "63", component);

              out.n(marko_node8, component);

              out.be("div", marko_attrs31, "65", component);

              out.be("div", marko_attrs32, "66", component);

              out.n(marko_node9, component);

              out.be("div", marko_attrs33, "68", component);

              out.be("h6", marko_attrs34, "69", component);

              Locale_tag({
                  text: "Best Selling"
                }, out, __component, "70");

              out.t(" ");

              out.ee();

              out.n(marko_node10, component);

              out.ee();

              out.ee();

              if (state.generalReports) {
                out.n(marko_node47, component);
              }

              out.ee();

              out.be("div", marko_attrs35, "73", component);

              out.be("div", marko_attrs36, "74", component);

              out.n(marko_node11, component);

              out.be("div", marko_attrs37, "76", component);

              out.be("h6", marko_attrs38, "77", component);

              Locale_tag({
                  text: "Lowest Selling"
                }, out, __component, "78");

              out.ee();

              out.n(marko_node12, component);

              out.ee();

              out.ee();

              if (state.generalReports) {
                out.n(marko_node48, component);
              }

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.n(marko_node13, component);

              out.ee();

              out.be("section", null, "91", component);

              out.be("div", marko_attrs39, "92", component);

              out.be("div", marko_attrs40, "93", component);

              out.be("div", marko_attrs41, "94", component);

              out.be("div", marko_attrs42, "95", component);

              out.be("div", marko_attrs43, "96", component);

              out.be("h4", marko_attrs44, "97", component);

              Locale_tag({
                  text: "Order Summary"
                }, out, __component, "98");

              out.ee();

              out.n(marko_node14, component);

              out.ee();

              out.n(marko_node15, component);

              out.ee();

              out.ee();

              out.be("div", marko_attrs45, "105", component);

              out.be("div", marko_attrs46, "106", component);

              out.be("div", marko_attrs47, "107", component);

              out.be("h4", marko_attrs48, "108", component);

              Locale_tag({
                  text: "Sales History"
                }, out, __component, "109");

              out.ee();

              out.ee();

              out.be("div", marko_attrs49, "110", component);

              out.be("div", marko_attrs50, "111", component);

              if (state.salesHistory && state.salesHistory.length) {
                marko_forOf(state.salesHistory, function(sales, index) {
                  var $keyValue$0 = "@" + ("sale-" + index),
                      $keyScope$0 = "[" + ($keyValue$0 + "]");

                  out.e("div", marko_attrs111, $keyValue$0, component, 2)
                    .e("div", marko_attrs112, "112" + $keyScope$0, component, 2)
                      .e("p", marko_attrs114, "113" + $keyScope$0, component, 1)
                        .t(sales.items[0].name, component)
                      .e("small", marko_attrs115, "114" + $keyScope$0, component, 1)
                        .t(formatDate(sales.created_at, "calendar"), component)
                    .e("div", marko_attrs113, "115" + $keyScope$0, component, 0);
                });
              }

              out.ee();

              out.be("div", marko_attrs51, "116", component);

              out.n(marko_node16, component);

              if (state.generalReports) {
                out.n(marko_node49, component);
              }

              out.n(marko_node17, component);

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.be("section", null, "121", component);

              out.be("div", marko_attrs52, "122", component);

              out.be("div", marko_attrs53, "123", component);

              out.be("h4", marko_attrs54, "124", component);

              Locale_tag({
                  text: "Trafic Analytics"
                }, out, __component, "125");

              out.ee();

              out.n(marko_node18, component);

              out.ee();

              out.be("div", marko_attrs55, "127", component);

              out.be("div", marko_attrs56, "128", component);

              out.be("div", marko_attrs57, "129", component);

              out.be("div", marko_attrs58, "130", component);

              out.n(marko_node19, component);

              out.be("span", marko_attrs59, "132", component);

              Locale_tag({
                  text: "Customers"
                }, out, __component, "133");

              out.ee();

              out.n(marko_node20, component);

              out.ee();

              out.n(marko_node21, component);

              out.n(marko_node22, component);

              out.ee();

              out.n(marko_node23, component);

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.be("section", marko_attrs60, "150", component);

              out.be("div", marko_attrs61, "151", component);

              out.be("div", marko_attrs62, "152", component);

              out.be("div", marko_attrs63, "153", component);

              out.be("h4", marko_attrs64, "154", component);

              Locale_tag({
                  text: "Good Impressions Feeds"
                }, out, __component, "155");

              out.ee();

              out.n(marko_node24, component);

              out.ee();

              out.be("div", marko_attrs65, "157", component);

              out.be("div", marko_attrs66, "158", component);

              out.n(marko_node25, component);

              out.be("ul", marko_attrs67, "160", component);

              out.be("li", null, "161", component);

              out.t(" ");

              out.n(marko_node26, component);

              Locale_tag({
                  text: "Products"
                }, out, __component, "163");

              out.ee();

              out.be("li", null, "164", component);

              out.t(" ");

              out.n(marko_node27, component);

              Locale_tag({
                  text: "Customer Services"
                }, out, __component, "166");

              out.ee();

              out.be("li", null, "167", component);

              out.t(" ");

              out.n(marko_node28, component);

              Locale_tag({
                  text: "Search"
                }, out, __component, "169");

              out.ee();

              out.be("li", null, "170", component);

              out.t(" ");

              out.n(marko_node29, component);

              Locale_tag({
                  text: "Marketing"
                }, out, __component, "172");

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.n(marko_node30, component);

              out.ee();

              out.ee();

              out.be("div", marko_attrs68, "174", component);

              out.be("div", marko_attrs69, "175", component);

              out.be("div", marko_attrs70, "176", component);

              out.be("div", marko_attrs71, "177", component);

              out.be("div", marko_attrs72, "178", component);

              out.be("div", marko_attrs73, "179", component);

              out.n(marko_node31, component);

              out.be("div", marko_attrs74, "182", component);

              Locale_tag({
                  text: "New Products"
                }, out, __component, "183");

              out.ee();

              out.e("h4", marko_attrs75, "184", component, 1)
                .t(state.newProducts, component);

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.be("div", marko_attrs76, "185", component);

              out.be("div", marko_attrs77, "186", component);

              out.be("div", marko_attrs78, "187", component);

              out.be("div", marko_attrs79, "188", component);

              out.n(marko_node32, component);

              out.be("div", marko_attrs80, "191", component);

              Locale_tag({
                  text: "New Customers"
                }, out, __component, "192");

              out.ee();

              out.e("h4", marko_attrs81, "193", component, 1)
                .t(state.newCustomers, component);

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.be("div", marko_attrs82, "194", component);

              out.be("div", marko_attrs83, "195", component);

              out.be("div", marko_attrs84, "196", component);

              out.n(marko_node33, component);

              out.be("div", marko_attrs85, "200", component);

              if (state.generalReports) {}

              out.be("small", marko_attrs86, "201", component);

              Locale_tag({
                  text: "Customers Income"
                }, out, __component, "202");

              out.ee();

              out.ee();

              out.ee();

              out.n(marko_node34, component);

              out.ee();

              out.ee();

              out.be("div", marko_attrs87, "204", component);

              out.be("div", marko_attrs88, "205", component);

              out.be("div", marko_attrs89, "206", component);

              out.n(marko_node35, component);

              out.be("div", marko_attrs90, "210", component);

              if (state.generalReports) {}

              out.be("small", marko_attrs91, "211", component);

              Locale_tag({
                  text: "Resellers Income"
                }, out, __component, "212");

              out.ee();

              out.ee();

              out.ee();

              out.n(marko_node36, component);

              out.ee();

              out.ee();

              out.be("div", marko_attrs92, "214", component);

              out.be("div", marko_attrs93, "215", component);

              out.be("h4", marko_attrs94, "216", component);

              Locale_tag({
                  text: "Revenue Growth"
                }, out, __component, "217");

              out.ee();

              out.be("div", marko_attrs95, "218", component);

              if (state.generalReports) {}

              out.n(marko_node37, component);

              out.ee();

              out.ee();

              out.n(marko_node38, component);

              out.ee();

              out.be("div", marko_attrs96, "223", component);

              out.be("div", marko_attrs97, "224", component);

              out.be("h4", marko_attrs98, "225", component);

              Locale_tag({
                  text: "Profit Report"
                }, out, __component, "226");

              out.ee();

              out.n(marko_node39, component);

              out.ee();

              out.be("div", marko_attrs99, "228", component);

              out.be("div", marko_attrs100, "229", component);

              out.be("div", marko_attrs101, "230", component);

              out.n(marko_node40, component);

              out.be("div", marko_attrs102, "232", component);

              if (state.generalReports) {}

              out.n(marko_node41, component);

              out.ee();

              out.ee();

              out.be("div", marko_attrs103, "234", component);

              out.n(marko_node42, component);

              out.be("div", marko_attrs104, "236", component);

              if (state.generalReports) {}

              out.n(marko_node43, component);

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              out.be("div", marko_attrs105, "238", component);

              out.be("div", marko_attrs106, "239", component);

              out.be("h4", marko_attrs107, "240", component);

              Locale_tag({
                  text: "Referrals"
                }, out, __component, "241");

              out.ee();

              out.ee();

              out.n(marko_node44, component);

              out.ee();

              out.be("div", marko_attrs108, "250", component);

              out.be("div", marko_attrs109, "251", component);

              out.be("h4", marko_attrs110, "252", component);

              Locale_tag({
                  text: "Subscriptions"
                }, out, __component, "253");

              out.ee();

              out.n(marko_node45, component);

              out.ee();

              out.n(marko_node46, component);

              out.ee();

              out.ee();
            }
          }, out, __component, "4");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
